import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function PriceSection() {
  return <section id="offer" className="py-24 px-6 lg:px-8 bg-brand-darker text-white relative overflow-hidden" data-id="element-96">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-10 pointer-events-none" data-id="element-97">
        <div className="absolute inset-0 bg-brand-accent rounded-full blur-[100px]" data-id="element-98"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-800/40 backdrop-blur-md border border-slate-700 rounded-3xl p-8 md:p-12 lg:p-16 shadow-2xl" data-id="element-100">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-101">
            Tu Hoja de Ruta Completa
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-102">
            Esta guía completa, junto con plantillas, checklists y ejemplos
            reales, es tu hoja de ruta para construir tu propio
            micro-emprendimiento digital en solo 7 días.
          </p>

          <div className="mb-10" data-id="element-103">
            <p className="text-slate-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-104">
              Precio regular
            </p>
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-105">
              <span className="text-3xl md:text-4xl font-heading font-bold text-slate-500 line-through" data-id="element-106">
                $27 USD
              </span>
            </div>
            <p className="text-brand-accent uppercase tracking-widest text-sm font-bold mb-2" data-id="element-107">
              Oferta especial
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-108">
              <span className="text-6xl md:text-7xl font-heading font-extrabold text-brand-accent" data-id="element-109">
                $7.39
              </span>
              <span className="text-2xl text-slate-400 font-bold mt-4" data-id="element-110">
                USD
              </span>
            </div>
          </div>

          <a href="https://www.tumundoequilibrado.com/cart/51311188541735:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-10 py-5 bg-brand-accent hover:bg-brand-accentHover text-brand-darker font-bold rounded-xl text-xl transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] flex items-center justify-center gap-3 group mx-auto mb-6 no-underline" data-id="element-111">
            Obtén acceso inmediato
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-112" />
          </a>

          <p className="text-slate-400 font-medium" data-id="element-113">
            Haz clic aquí para comenzar hoy mismo
          </p>

          <div className="mt-8 pt-8 border-t border-slate-700 flex items-center justify-center gap-2 text-slate-400 text-sm" data-id="element-114">
            <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-115" />
            <span data-id="element-116">Pago 100% seguro y acceso inmediato</span>
          </div>
        </motion.div>
      </div>
    </section>;
}